import { useEffect, useRef } from "react";
import { useLoaderData } from "react-router-dom";

import ResponseModals from "../../Common/Modals/components/ResponseModals";
import useModalHandler from "../../Common/Modals/hooks/useModalHandler";
import { setModalHandlerInstance } from "../../Common/Modals/hooks/useModalSingleton";

import LeftPanel from "./containers/LeftPanel";
import RightPanel from "./containers/RightPanel";
import useFetchData from "./hooks/useFetchData";

export default function ViewManagement() {
  const { viewName, id } = useLoaderData();
  const requestKeyRef = useRef(null);
  const handlers = useModalHandler();
  setModalHandlerInstance(handlers);
  const { fetchViewDetails } = useFetchData();

  useEffect(() => {
    const requestKey = `${viewName}:${id}`;
    if (requestKeyRef.current === requestKey) {
      return;
    }

    requestKeyRef.current = requestKey;
    fetchViewDetails();
  }, [fetchViewDetails, id, viewName]);

  return (
    <div className="flex h-full w-full flex-col items-start justify-start p-2">
      <div className="flex h-full min-h-0 w-full flex-row justify-between gap-6 p-2">
        <LeftPanel />
        <RightPanel />
      </div>
      <ResponseModals {...handlers} />
    </div>
  );
}
